import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const emp2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Singapore', 'Indonesia', 'Malaysia', 'Vietnam', 'Thailand', 'Philippines']
    },
    yAxis: {
        min: 0,
        title: {
            text: '# of job openings'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Job openings',
        data: [1100, 1800, 1050, 450, 1100, 1050]
    }]
}



export class ChapterFiftyThree extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="Remuneration for software developers vary widely depending on where the startups they are working for are based. The average front-end developer in Vietnam earned $21,500 a year, less than one-third of the salary of an applications developer in Singapore." />

        <TextHolder text="Among SEA nations, Indonesia has the highest demand for developers, probably because of its comparatively large population. On LinkedIn, there are more than a thousand professional software development job openings in Indonesia. Singapore put in an impressive showing as well, with 1,119 job vacancies to Indonesia’s 1,845. These results aren’t surprising, given that Singapore is often the regional headquarters for multinational corporations." />




                      <div className="block-outer block-outer-tableholder">
                        <div className="block-inner block-inner-tableholder">
                          <table id="t01">
                          <tbody>
                            <tr>
                              <th>Countries</th>
                              <th>Low end (USD)</th>
                              <th>High end (USD)</th>
                              <th>Average (USD)</th>
                              <th>Role</th>
                            </tr>
                            <tr>
                              <td>Indonesia</td>
                              <td>$17,227</td>
                              <td>$41,344</td>
                              <td>$29,286</td>
                              <td>Software Developer</td>
                            </tr>
                            <tr>
                              <td>Kuala Lumpur</td>
                              <td>$23,645</td>
                              <td>$48,768</td>
                              <td>$36,207</td>
                              <td>Software Engineer/Developer</td>
                            </tr>
                            <tr>
                              <td>Philippines</td>
                              <td>$20,584</td>
                              <td>$54,266</td>
                              <td>$37,425</td>
                              <td>Developer (Web & Mobile)</td>
                            </tr>
                            <tr>
                              <td>Singapore</td>
                              <td>$51,095</td>
                              <td>$94,891</td>
                              <td>$72,993</td>
                              <td>Applications Developer</td>
                            </tr>
                            <tr>
                              <td>Thailand</td>
                              <td>$28,443</td>
                              <td>$50,898</td>
                              <td>$39,671</td>
                              <td>Software Developer</td>
                            </tr>
                            <tr>
                              <td>Vietnam</td>
                              <td>$20,000</td>
                              <td>$30,000</td>
                              <td>$25,000</td>
                              <td>Java/PHP/.NET Engineer</td>
                            </tr>
                            <tr>
                              <td>Vietnam</td>
                              <td>$18,000</td>
                              <td>$25,000</td>
                              <td>$21,500</td>
                              <td>Front-end Developer</td>
                            </tr>

                            </tbody>
                          </table>
                          <div className="highcharts-notes">
                            <p> </p>
                            <p> Sources: <a href="https://www.robertwalters.com/content/dam/robert-walters/global/files/salary-survey/salary-survey-2018-southeast-asia-greater-china.pdf">Robert Walters </a>

                            </p>
                          </div>
                      </div>

                    </div>



                  <Highchartscomponent   chartsText="Software developer job openings by country" options={emp2} source="Source: LinkedIn" />

                  <TextHolder textTitle="Major international tech companies with offices in SEA countries"/>
                                        <div className="block-outer block-outer-tableholder">
                                          <div className="block-inner block-inner-tableholder">
                                            <table id="t01">
                                            <tbody>
                                              <tr>
                                                <th></th>
                                                <th>Vietnam</th>
                                                <th>Thailand</th>
                                                <th>Indonesia</th>
                                                <th>Singapore</th>
                                                <th>Malaysia</th>
                                                <th>Philippines</th>

                                              </tr>
                                              <tr>
                                                <td>Netflix</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>IBM</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Facebook</td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Google</td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Microsoft</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>LinkedIn</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Twitter</td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Skyscanner</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Paypal</td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Cisco</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>VMWare</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>SalesForce</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Amazon</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Booking.com</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Intel</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Agoda</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Apple</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Oracle</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                                <td>Yes</td>
                                              </tr>
                                              <tr>
                                                <td>Samsung</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Yes</td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td>Country total</td>
                                                <td>9</td>
                                                <td>12</td>
                                                <td>12</td>
                                                <td>20</td>
                                                <td>12</td>
                                                <td>10</td>
                                              </tr>
                                              </tbody>
                                              </table>
                                            <div className="highcharts-notes">
                                              <p> </p>
                                              
                                            </div>


                                        </div>

                                      </div>

          <TextHolder text="Salaries in SEA are still too low to attract world-class talent. Nayasan Munusamy of MoneyMatch said it best: “At the end of the day, the world is pretty fair in terms of demand and supply. If you pay peanuts, you get monkeys. Do you have any idea how much a full stack engineer in a Series A startup in Silicon Valley is paid compared to a Malaysian Series A startup? Once you obtain this data for yourself, you will realize why SEA can't attract more skilled workers. It's really that simple.”" />


          <TextHolder text="The best workers and engineers work for the best startups, which offer the best remuneration packages. It is no different than other industries such as banking, he pointed out." />

          <TextHolder text="“Only when the funding scene in SEA changes, and the VCs here and investors start to accept much higher valuations, then would startups be able to offer the best remuneration packages and stop the brain drain of highly skilled workers and engineers who migrate elsewhere to find more lucrative opportunities for themselves and their families,” Munusamy said. " />
          <TextHolder text="One way to attract tech talent is to create connections with developed countries so as to identify potential candidates or perhaps to offshore work overseas. Barak Sharabi of Spark Accelerator said greater collaboration among entrepreneurs, companies, academia and government should be encouraged, perhaps as another way of tapping talent." />
          <TextHolder text="Tech skills are good, but as Jonathan Eg of Partipost pointed out, soft skills are also crucial because entrepreneurs need to communicate well with their employees, investors and customers." />

          <TextHolder text="" />

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/53.js